// extracted by mini-css-extract-plugin
export default {"DashboardLayout":"DashboardLayout_DashboardLayout__Gofq7","LeftSection":"DashboardLayout_LeftSection__21+lZ","RightSection":"DashboardLayout_RightSection__MDQq6"};